import { Box, Image, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Close } from '../../Icons/Close';
import { ShopListsProps } from '../../interfaces/components';
import ModernScrollList from './ModernScrollList';

const ModernShopList = ({ active, setActive, subcategory, list, headerImg }: ShopListsProps) => {
  const [listItems, setListItems] = useState<string[]>([]);

  useEffect(() => {
    if (list && list != '') {
      const newList = list.split(',');
      setListItems(newList);
    }
  }, [list]);

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        // backgroundColor="rgba(255, 255, 255, 1);"
        padding={['15px', '15px', '15px', '15px']}
        width={['400px', '400px', '400px', '400px', '400px']}
        height={['700px', '700px', '700px', '700px', '700px']}
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['30px', '30px', '30px']}
          right={['30px', '30px', '30px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Box
          bg="white"
          borderRadius="160px 160px 0 0"
          h="160px"
          display="flex"
          flexDir="column"
          justifyContent="end"
          alignItems="center"
          pb="20px"
          gap="2"
          border="1px solid #C29F6B"
        >
          <Image src={headerImg} w="130px" objectFit="contain" alt="village" />
          <Text
            textAlign="center"
            fontWeight="400"
            fontFamily="SangBleuBPLight"
            fontSize={['32px', '32px', '32px', '36px', '36px']}
          >
            {subcategory}
          </Text>
        </Box>

        <Box m="0px" display="flex" justifyContent="center" bg="white" border="1px solid #C29F6B" p="25px 0px">
          <ModernScrollList list={listItems} />
        </Box>
      </Box>
    </>
  );
};

export default ModernShopList;
